import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pokhara-bike-rental/pokhara-bike-rental/src/app/(frontend)/about-us/components/AboutUsInteractive.tsx");
